import {sendRecaptchaData} from './recaptcha'
import {sendAmocrmData} from './proxy/amocrm'
import {sendEsputnikData} from './proxy/esputnik'
import {sendHrData} from './proxy/hr'

export default class RestClient {
  constructor() {
    this.proxy = {
      amocrm: {
        post(formRequest) {
          return sendAmocrmData(formRequest)
        }
      },
      esputnik: {
        post(formRequest) {
          return sendEsputnikData(formRequest)
        }
      },
      hr: {
        post(formRequest) {
          return sendHrData(formRequest)
        }
      }
    }

    this.recaptcha = {
      post(token) {
        return sendRecaptchaData(token)
      }
    }
  }
}